/**
 * @generated SignedSource<<e1c5d6359dbad0d341d506ff7414a309>>
 * @relayHash 751cfcf3fd1ddf8776f7df66a461accf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8d5bfd972fde66029f4613327f0f763b28fe23988fcf40528ed023963d9019f0

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
export type JiraBulkEditMultiSelectFieldOptions = "ADD" | "REMOVE" | "REMOVE_ALL" | "REPLACE" | "%future added value";
export type JiraGoalStatus = "ARCHIVED" | "AT_RISK" | "CANCELLED" | "COMPLETED" | "DONE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
export type JiraIssueLinkDirection = "BOTH" | "INWARD" | "OUTWARD" | "%future added value";
export type JiraNumberFieldFormatStyle = "CURRENCY" | "DECIMAL" | "PERCENT" | "UNIT" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
export type JiraTimeFormat = "DAYS" | "HOURS" | "PRETTY" | "%future added value";
export type JiraTimeUnit = "DAY" | "HOUR" | "MINUTE" | "WEEK" | "%future added value";
export type JiraIssueCreateInput = {
  fields: JiraIssueFieldsInput;
  issueTypeId: string;
  projectId: string;
  rank?: JiraIssueCreateRankInput | null | undefined;
  transitionId?: number | null | undefined;
};
export type JiraIssueFieldsInput = {
  affectedServicesField?: JiraAffectedServicesFieldInput | null | undefined;
  assetsField?: JiraAssetFieldInput | null | undefined;
  atlassianTeamFields?: ReadonlyArray<JiraAtlassianTeamFieldInput> | null | undefined;
  cascadingSelectFields?: ReadonlyArray<JiraCascadingSelectFieldInput> | null | undefined;
  clearableNumberFields?: ReadonlyArray<JiraClearableNumberFieldInput> | null | undefined;
  cmdbFields?: ReadonlyArray<JiraCMDBFieldInput> | null | undefined;
  colorFields?: ReadonlyArray<JiraColorFieldInput> | null | undefined;
  datePickerFields?: ReadonlyArray<JiraDateFieldInput> | null | undefined;
  dateTimePickerFields?: ReadonlyArray<JiraDateTimeFieldInput> | null | undefined;
  entitlementField?: JiraEntitlementFieldInput | null | undefined;
  epicLinkField?: JiraEpicLinkFieldInput | null | undefined;
  issueLinks?: JiraIssueLinksFieldInput | null | undefined;
  issueType?: JiraIssueTypeInput | null | undefined;
  jiraForgeGroupsFields?: ReadonlyArray<JiraForgeGroupsFieldInput> | null | undefined;
  jiraForgeStringsFields?: ReadonlyArray<JiraForgeStringsFieldInput> | null | undefined;
  jiraForgeUsersFields?: ReadonlyArray<JiraForgeUsersFieldInput> | null | undefined;
  labelsFields?: ReadonlyArray<JiraLabelsFieldInput> | null | undefined;
  multipleGroupPickerFields?: ReadonlyArray<JiraMultipleGroupPickerFieldInput> | null | undefined;
  multipleSelectClearableUserPickerFields?: ReadonlyArray<JiraMultipleSelectClearableUserPickerFieldInput> | null | undefined;
  multipleSelectFields?: ReadonlyArray<JiraMultipleSelectFieldInput> | null | undefined;
  multipleSelectUserPickerFields?: ReadonlyArray<JiraMultipleSelectUserPickerFieldInput> | null | undefined;
  multipleVersionPickerFields?: ReadonlyArray<JiraMultipleVersionPickerFieldInput> | null | undefined;
  multiselectComponents?: JiraMultiSelectComponentFieldInput | null | undefined;
  numberFields?: ReadonlyArray<JiraNumberFieldInput> | null | undefined;
  organizationField?: JiraOrganizationFieldInput | null | undefined;
  originalEstimateField?: JiraDurationFieldInput | null | undefined;
  parentField?: JiraParentFieldInput | null | undefined;
  peopleFields?: ReadonlyArray<JiraPeopleFieldInput> | null | undefined;
  priority?: JiraPriorityInput | null | undefined;
  projectFields?: ReadonlyArray<JiraProjectFieldInput> | null | undefined;
  resolution?: JiraResolutionInput | null | undefined;
  respondersField?: JiraServiceManagementRespondersFieldInput | null | undefined;
  richTextFields?: ReadonlyArray<JiraRichTextFieldInput> | null | undefined;
  security?: JiraSecurityLevelInput | null | undefined;
  singleGroupPickerFields?: ReadonlyArray<JiraSingleGroupPickerFieldInput> | null | undefined;
  singleLineTextFields?: ReadonlyArray<JiraSingleLineTextFieldInput> | null | undefined;
  singleOrganizationField?: JiraSingleOrganizationFieldInput | null | undefined;
  singleSelectClearableUserPickerFields?: ReadonlyArray<JiraUserFieldInput> | null | undefined;
  singleSelectFields?: ReadonlyArray<JiraSingleSelectFieldInput> | null | undefined;
  singleSelectUserPickerFields?: ReadonlyArray<JiraSingleSelectUserPickerFieldInput> | null | undefined;
  singleVersionPickerFields?: ReadonlyArray<JiraSingleVersionPickerFieldInput> | null | undefined;
  sprintsField?: JiraSprintFieldInput | null | undefined;
  status?: JiraStatusInput | null | undefined;
  teamFields?: ReadonlyArray<JiraTeamFieldInput> | null | undefined;
  timeTrackingField?: JiraTimeTrackingFieldInput | null | undefined;
  urlFields?: ReadonlyArray<JiraUrlFieldInput> | null | undefined;
};
export type JiraAffectedServicesFieldInput = {
  affectedServices: ReadonlyArray<JiraAffectedServicesInput>;
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  fieldId: string;
};
export type JiraAffectedServicesInput = {
  serviceId: string;
};
export type JiraAssetFieldInput = {
  assets: ReadonlyArray<JiraAssetInput>;
  fieldId: string;
};
export type JiraAssetInput = {
  appKey: string;
  originId: string;
  serializedOrigin: string;
  value: string;
};
export type JiraAtlassianTeamFieldInput = {
  fieldId: string;
  team: JiraAtlassianTeamInput;
};
export type JiraAtlassianTeamInput = {
  teamId: string;
};
export type JiraCascadingSelectFieldInput = {
  childOptionValue?: JiraSelectedOptionInput | null | undefined;
  fieldId: string;
  parentOptionValue: JiraSelectedOptionInput;
};
export type JiraSelectedOptionInput = {
  id?: string | null | undefined;
  optionId?: string | null | undefined;
};
export type JiraClearableNumberFieldInput = {
  fieldId: string;
  value?: number | null | undefined;
};
export type JiraCMDBFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  cmdbObjects: ReadonlyArray<JiraCMDBInput>;
  fieldId: string;
};
export type JiraCMDBInput = {
  cmdbObjectGlobalId: string;
};
export type JiraColorFieldInput = {
  color: JiraColorInput;
  fieldId: string;
};
export type JiraColorInput = {
  name: string;
};
export type JiraDateFieldInput = {
  date: JiraDateInput;
  fieldId: string;
};
export type JiraDateInput = {
  formattedDate: string;
};
export type JiraDateTimeFieldInput = {
  dateTime: JiraDateTimeInput;
  fieldId: string;
};
export type JiraDateTimeInput = {
  formattedDateTime: string;
};
export type JiraEntitlementFieldInput = {
  entitlement: JiraEntitlementInput;
  fieldId: string;
};
export type JiraEntitlementInput = {
  entitlementId: string;
};
export type JiraEpicLinkFieldInput = {
  epicLink: JiraEpicLinkInput;
  fieldId: string;
};
export type JiraEpicLinkInput = {
  issueKey: string;
};
export type JiraIssueLinksFieldInput = {
  direction?: JiraIssueLinkDirection | null | undefined;
  linkTypeId?: string | null | undefined;
  linkTypeName?: string | null | undefined;
  linkedIssueKeys?: ReadonlyArray<string> | null | undefined;
};
export type JiraIssueTypeInput = {
  id?: string | null | undefined;
  issueTypeId: string;
};
export type JiraForgeGroupsFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  fieldId: string;
  selectedGroups: ReadonlyArray<JiraGroupInput>;
};
export type JiraGroupInput = {
  groupName: string;
};
export type JiraForgeStringsFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  fieldId: string;
  labels: ReadonlyArray<JiraLabelsInput>;
};
export type JiraLabelsInput = {
  name?: string | null | undefined;
};
export type JiraForgeUsersFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  fieldId: string;
  users: ReadonlyArray<JiraUserInput>;
};
export type JiraUserInput = {
  accountId: string;
};
export type JiraLabelsFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  fieldId: string;
  labels?: ReadonlyArray<JiraLabelsInput> | null | undefined;
};
export type JiraMultipleGroupPickerFieldInput = {
  fieldId: string;
  groups: ReadonlyArray<JiraGroupInput>;
};
export type JiraMultipleSelectClearableUserPickerFieldInput = {
  fieldId: string;
  users?: ReadonlyArray<JiraUserInput> | null | undefined;
};
export type JiraMultipleSelectFieldInput = {
  fieldId: string;
  options: ReadonlyArray<JiraSelectedOptionInput>;
};
export type JiraMultipleSelectUserPickerFieldInput = {
  fieldId: string;
  users: ReadonlyArray<JiraUserInput>;
};
export type JiraMultipleVersionPickerFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  fieldId: string;
  versions: ReadonlyArray<JiraVersionInput>;
};
export type JiraVersionInput = {
  versionId?: string | null | undefined;
};
export type JiraMultiSelectComponentFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  components?: ReadonlyArray<JiraComponentInput> | null | undefined;
  fieldId: string;
};
export type JiraComponentInput = {
  componentId: string;
};
export type JiraNumberFieldInput = {
  fieldId: string;
  value: number;
};
export type JiraOrganizationFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  fieldId: string;
  organizations: ReadonlyArray<JiraOrganizationsInput>;
};
export type JiraOrganizationsInput = {
  organizationId: string;
};
export type JiraDurationFieldInput = {
  originalEstimateField?: string | null | undefined;
};
export type JiraParentFieldInput = {
  issueId: string;
};
export type JiraPeopleFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  fieldId: string;
  users: ReadonlyArray<JiraUserInput>;
};
export type JiraPriorityInput = {
  priorityId: string;
};
export type JiraProjectFieldInput = {
  fieldId: string;
  project: JiraProjectInput;
};
export type JiraProjectInput = {
  id?: string | null | undefined;
  projectId: string;
};
export type JiraResolutionInput = {
  resolutionId: string;
};
export type JiraServiceManagementRespondersFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null | undefined;
  fieldId: string;
  responders: ReadonlyArray<JiraServiceManagementResponderFieldInput>;
};
export type JiraServiceManagementResponderFieldInput = {
  responderId: string;
};
export type JiraRichTextFieldInput = {
  fieldId: string;
  richText: JiraRichTextInput;
};
export type JiraRichTextInput = {
  adfValue?: AGG$JSON | null | undefined;
  wikiText?: string | null | undefined;
};
export type JiraSecurityLevelInput = {
  securityLevelId: string;
};
export type JiraSingleGroupPickerFieldInput = {
  fieldId: string;
  group: JiraGroupInput;
};
export type JiraSingleLineTextFieldInput = {
  fieldId: string;
  text?: string | null | undefined;
};
export type JiraSingleOrganizationFieldInput = {
  fieldId: string;
  organization: JiraOrganizationsInput;
};
export type JiraUserFieldInput = {
  fieldId: string;
  user?: JiraUserInput | null | undefined;
};
export type JiraSingleSelectFieldInput = {
  fieldId: string;
  option: JiraSelectedOptionInput;
};
export type JiraSingleSelectUserPickerFieldInput = {
  fieldId: string;
  user: JiraUserInput;
};
export type JiraSingleVersionPickerFieldInput = {
  fieldId: string;
  version: JiraVersionInput;
};
export type JiraSprintFieldInput = {
  fieldId: string;
  sprints: ReadonlyArray<JiraSprintInput>;
};
export type JiraSprintInput = {
  sprintId: string;
};
export type JiraStatusInput = {
  statusId: string;
};
export type JiraTeamFieldInput = {
  fieldId: string;
  team: JiraTeamInput;
};
export type JiraTeamInput = {
  teamId: string;
};
export type JiraTimeTrackingFieldInput = {
  originalEstimate?: string | null | undefined;
  timeRemaining?: string | null | undefined;
};
export type JiraUrlFieldInput = {
  fieldId: string;
  url: string;
};
export type JiraIssueCreateRankInput = {
  afterIssueId?: string | null | undefined;
  beforeIssueId?: string | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type CreateIssueControllerMutation$variables = {
  fieldIdsOrAliases: ReadonlyArray<string>;
  fieldSetIds: ReadonlyArray<string>;
  isConditionalFormattingEnabled: boolean;
  isDensityFull: boolean;
  isEditableSyncLoaded: boolean;
  isIdFieldEnabled: boolean;
  isInlineEditingEnabled: boolean;
  isIssueHierarchyEnabled: boolean;
  isLinkRelationshipFieldEnabled: boolean;
  isTimelineEnabled: boolean;
  issueCreateInput: JiraIssueCreateInput;
  issueSearchInput: JiraIssueSearchInput;
  projectKey?: string | null | undefined;
  shouldQueryFieldsByIdOrAlias: boolean;
  shouldQueryMatchesIssueSearch: boolean;
};
export type CreateIssueControllerMutation$data = {
  readonly jira: {
    readonly createIssue: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
      }> | null | undefined;
      readonly issue: {
        readonly $updatableFragmentSpreads: FragmentRefs<"highlightIssueRow">;
        readonly __id?: string;
        readonly canHaveChildIssues?: boolean | null | undefined;
        readonly fieldSetsById: {
          readonly __id?: string;
          readonly " $fragmentSpreads": FragmentRefs<"IssueRow_fieldSets">;
        } | null | undefined;
        readonly fieldsByIdOrAlias?: ReadonlyArray<{
          readonly __typename: string;
          readonly fieldId: string;
          readonly fieldOption?: {
            readonly optionId: string;
          } | null | undefined;
          readonly number?: number | null | undefined;
          readonly priority?: {
            readonly priorityId: string;
          } | null | undefined;
          readonly selectedLabelsConnection?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly name: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly selectedOption?: {
            readonly optionId: string;
          } | null | undefined;
          readonly selectedOptions?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly optionId: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly selectedSprintsConnection?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly sprintId: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly selectedVersionsConnection?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly versionId: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly status?: {
            readonly name: string | null | undefined;
            readonly statusId: string;
          };
          readonly user?: {
            readonly accountId: string;
          } | null | undefined;
          readonly version?: {
            readonly versionId: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly id: string;
        readonly issueId: string;
        readonly issueTypeField?: {
          readonly id: string;
          readonly issueType: {
            readonly hierarchy: {
              readonly level: number | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly key: string;
        readonly matchesIssueSearch?: boolean | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CreateIssueControllerMutation$rawResponse = {
  readonly jira: {
    readonly createIssue: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly __typename: "BulkMutationErrorExtension";
          readonly id: string;
          readonly statusCode: number | null | undefined;
        } | {
          readonly __typename: string;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
      }> | null | undefined;
      readonly issue: {
        readonly __typename: "JiraIssue";
        readonly __id?: string;
        readonly canHaveChildIssues: boolean | null | undefined;
        readonly fieldSetsById: {
          readonly __id?: string;
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly fieldSetId: string | null | undefined;
              readonly fields: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly __typename: "JiraAffectedServicesField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraAffectedServicesField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly selectedAffectedServicesConnection: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly id: string;
                          readonly name: string | null | undefined;
                          readonly serviceId: string;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraCMDBField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraCMDBField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly selectedCmdbObjectsConnection: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly avatar: {
                            readonly mediaClientConfig: {
                              readonly clientId: string | null | undefined;
                              readonly fileId: string | null | undefined;
                              readonly mediaBaseUrl: AGG$URL | null | undefined;
                              readonly mediaJwtToken: string | null | undefined;
                            } | null | undefined;
                            readonly url48: string | null | undefined;
                          } | null | undefined;
                          readonly label: string | null | undefined;
                          readonly objectId: string | null | undefined;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                      readonly errors: ReadonlyArray<{
                        readonly message: string | null | undefined;
                      }> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraCascadingSelectField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraCascadingSelectField";
                    readonly cascadingOption: {
                      readonly childOptionValue: {
                        readonly id: string;
                        readonly isDisabled: boolean | null | undefined;
                        readonly value: string | null | undefined;
                      } | null | undefined;
                      readonly parentOptionValue: {
                        readonly id: string;
                        readonly isDisabled: boolean | null | undefined;
                        readonly value: string | null | undefined;
                      } | null | undefined;
                    } | null | undefined;
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraCheckboxesField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraCheckboxesField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedOptions: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly id: string;
                          readonly value: string | null | undefined;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraCommentSummaryField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraCommentSummaryField";
                    readonly commentSummary: {
                      readonly canAddComment: boolean | null | undefined;
                      readonly totalCount: number | null | undefined;
                    } | null | undefined;
                    readonly fieldId: string;
                    readonly id: string;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraComponentsField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraComponentsField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedComponentsConnection: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly componentId?: string;
                          readonly id: string;
                          readonly label: string | null | undefined;
                          readonly value: string;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraConfluenceRemoteIssueLinksField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraConfluenceRemoteIssueLinksField";
                    readonly confluenceRemoteIssueLinks: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly href: string | null | undefined;
                          readonly id: string;
                          readonly pageContent: {
                            readonly __typename: "JiraConfluencePageContentDetails";
                            readonly href: string | null | undefined;
                          } | {
                            readonly __typename: string;
                          } | null | undefined;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                      readonly totalCount: number | null | undefined;
                    } | null | undefined;
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraDatePickerField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraDatePickerField";
                    readonly date: AGG$Date | null | undefined;
                    readonly fieldConfig: {
                      readonly isRequired: boolean | null | undefined;
                    } | null | undefined;
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraDateTimePickerField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraDateTimePickerField";
                    readonly dateTime: AGG$DateTime | null | undefined;
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraEpicLinkField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraEpicLinkField";
                    readonly epic: {
                      readonly color: string | null | undefined;
                      readonly id: string;
                      readonly key: string | null | undefined;
                      readonly summary: string | null | undefined;
                    } | null | undefined;
                    readonly fieldId: string;
                    readonly id: string;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraFallbackField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraFallbackField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly renderedFieldHtml: string | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraFlagField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraFlagField";
                    readonly fieldId: string;
                    readonly flag: {
                      readonly isFlagged: boolean | null | undefined;
                    } | null | undefined;
                    readonly id: string;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraGoalsField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraGoalsField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly issue: {
                      readonly id: string;
                    } | null | undefined;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedGoals: {
                      readonly __id?: string;
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly id: string;
                          readonly key: string | null | undefined;
                          readonly name: string | null | undefined;
                          readonly status: JiraGoalStatus | null | undefined;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraIssueLinkField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraIssueLinkField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly issueLinkConnection: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly id: string | null | undefined;
                          readonly issue: {
                            readonly fieldsById: {
                              readonly edges: ReadonlyArray<{
                                readonly node: {
                                  readonly __typename: "JiraStatusCategoryField";
                                  readonly id: string;
                                  readonly statusCategory: {
                                    readonly id: string;
                                    readonly statusCategoryId: string;
                                  };
                                } | {
                                  readonly __typename: string;
                                  readonly id: string;
                                } | null | undefined;
                              } | null | undefined> | null | undefined;
                            } | null | undefined;
                            readonly id: string;
                            readonly isResolved: boolean | null | undefined;
                            readonly key: string;
                            readonly webUrl: AGG$URL | null | undefined;
                          } | null | undefined;
                          readonly relationName: string | null | undefined;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                      readonly totalCount: number | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraIssueLinkRelationshipTypeField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraIssueLinkRelationshipTypeField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly isEditableInIssueView: boolean | null | undefined;
                    readonly issueLink: {
                      readonly direction: JiraIssueLinkDirection | null | undefined;
                      readonly id: string | null | undefined;
                      readonly relationName: string | null | undefined;
                      readonly type: {
                        readonly id: string;
                      } | null | undefined;
                    } | null | undefined;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraIssueTypeField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraIssueTypeField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly issueType: {
                      readonly avatar: {
                        readonly small: string | null | undefined;
                      } | null | undefined;
                      readonly id: string;
                      readonly issueTypeId?: string | null | undefined;
                      readonly name: string;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraLabelsField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraLabelsField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedLabelsConnection: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly color: {
                            readonly colorKey: string | null | undefined;
                            readonly id: string | null | undefined;
                          } | null | undefined;
                          readonly name: string | null | undefined;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                      readonly totalCount: number | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraMultipleGroupPickerField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraMultipleGroupPickerField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedGroupsConnection: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly groupId: string;
                          readonly id: string;
                          readonly name: string;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraMultipleSelectField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraMultipleSelectField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedOptions: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly id: string;
                          readonly optionId: string;
                          readonly value: string | null | undefined;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly selectedValues?: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly __typename: string;
                          readonly id: string;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraMultipleSelectUserPickerField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraMultipleSelectUserPickerField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedUsersConnection: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly __typename: "AtlassianAccountUser";
                          readonly accountId: string;
                          readonly accountStatus: AccountStatus;
                          readonly email: string | null | undefined;
                          readonly id: string;
                          readonly name: string;
                          readonly picture: AGG$URL;
                        } | {
                          readonly __typename: string;
                          readonly accountId: string;
                          readonly accountStatus: AccountStatus;
                          readonly id: string;
                          readonly name: string;
                          readonly picture: AGG$URL;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraMultipleVersionPickerField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraMultipleVersionPickerField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedVersionsConnection: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly id: string;
                          readonly label: string | null | undefined;
                          readonly name: string | null | undefined;
                          readonly value: string;
                          readonly versionId: string;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraNumberField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraNumberField";
                    readonly fieldId: string;
                    readonly formatConfig: {
                      readonly formatStyle: JiraNumberFieldFormatStyle | null | undefined;
                      readonly formatUnit: string | null | undefined;
                    } | null | undefined;
                    readonly id: string;
                    readonly isStoryPointField: boolean | null | undefined;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly number: number | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraOriginalTimeEstimateField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraOriginalTimeEstimateField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly issue: {
                      readonly id: string;
                      readonly timeTrackingField: {
                        readonly fieldId: string;
                        readonly id: string;
                        readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                        readonly name: string;
                        readonly originalEstimate: {
                          readonly timeInSeconds: AGG$Long | null | undefined;
                        } | null | undefined;
                        readonly timeTrackingSettings: {
                          readonly defaultFormat: JiraTimeFormat | null | undefined;
                          readonly defaultUnit: JiraTimeUnit | null | undefined;
                          readonly workingDaysPerWeek: number | null | undefined;
                          readonly workingHoursPerDay: number | null | undefined;
                        } | null | undefined;
                        readonly type: string;
                      } | null | undefined;
                    } | null | undefined;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraParentIssueField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraParentIssueField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly parentIssue: {
                      readonly fieldsById: {
                        readonly edges: ReadonlyArray<{
                          readonly node: {
                            readonly __typename: "JiraIssueTypeField";
                            readonly fieldId: string;
                            readonly id: string;
                            readonly issueType: {
                              readonly avatar: {
                                readonly xsmall: string | null | undefined;
                              } | null | undefined;
                              readonly hierarchy: {
                                readonly level: number | null | undefined;
                              } | null | undefined;
                              readonly id: string;
                              readonly issueTypeId: string | null | undefined;
                              readonly name: string;
                            } | null | undefined;
                          } | {
                            readonly __typename: "JiraSingleLineTextField";
                            readonly fieldId: string;
                            readonly id: string;
                            readonly text: string | null | undefined;
                          } | {
                            readonly __typename: "JiraStatusField";
                            readonly fieldId: string;
                            readonly id: string;
                            readonly status: {
                              readonly id: string;
                              readonly statusCategory: {
                                readonly id: string;
                                readonly statusCategoryId: string;
                              } | null | undefined;
                            };
                          } | {
                            readonly __typename: string;
                            readonly id: string;
                          } | null | undefined;
                        } | null | undefined> | null | undefined;
                      } | null | undefined;
                      readonly id: string;
                      readonly issueColorField: {
                        readonly color: {
                          readonly colorKey: string | null | undefined;
                          readonly id: string | null | undefined;
                        } | null | undefined;
                        readonly id: string;
                      } | null | undefined;
                      readonly issueId: string;
                      readonly issueTypeField: {
                        readonly fieldId?: string;
                        readonly id: string;
                        readonly issueType: {
                          readonly avatar: {
                            readonly xsmall: string | null | undefined;
                          } | null | undefined;
                          readonly hierarchy?: {
                            readonly level: number | null | undefined;
                          } | null | undefined;
                          readonly id: string;
                          readonly issueTypeId?: string | null | undefined;
                          readonly name: string;
                        } | null | undefined;
                      } | null | undefined;
                      readonly key: string;
                      readonly statusField: {
                        readonly fieldId: string;
                        readonly id: string;
                        readonly status: {
                          readonly id: string;
                          readonly statusCategory: {
                            readonly id: string;
                            readonly statusCategoryId: string;
                          } | null | undefined;
                        };
                      } | null | undefined;
                      readonly summaryField: {
                        readonly fieldId?: string;
                        readonly id: string;
                        readonly text: string | null | undefined;
                      } | null | undefined;
                      readonly webUrl: AGG$URL | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraPriorityField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraPriorityField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly isEditableInIssueView: boolean | null | undefined;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly priority: {
                      readonly iconUrl: AGG$URL | null | undefined;
                      readonly id: string;
                      readonly name: string | null | undefined;
                      readonly priorityId?: string;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraProjectField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraProjectField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly project: {
                      readonly avatar: {
                        readonly large: string | null | undefined;
                      } | null | undefined;
                      readonly id: string;
                      readonly key: string;
                      readonly name: string;
                      readonly projectId?: string | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraRadioSelectField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraRadioSelectField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedOption: {
                      readonly id: string;
                      readonly label: string | null | undefined;
                      readonly value: string;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraResolutionField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraResolutionField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly resolution: {
                      readonly id: string;
                      readonly name: string | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraRichTextField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraRichTextField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly richText: {
                      readonly adfValue: {
                        readonly convertedPlainText: {
                          readonly plainText: string | null | undefined;
                        } | null | undefined;
                        readonly json: AGG$JSON | null | undefined;
                      } | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraServiceManagementRequestTypeField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraServiceManagementRequestTypeField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly requestType: {
                      readonly avatar: {
                        readonly xsmall: string | null | undefined;
                      } | null | undefined;
                      readonly id: string;
                      readonly name: string | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraSingleLineTextField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraSingleLineTextField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly isEditableInIssueView: boolean | null | undefined;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly text: string | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraSingleSelectField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraSingleSelectField";
                    readonly fieldId: string;
                    readonly fieldOption: {
                      readonly color: {
                        readonly colorKey: string | null | undefined;
                        readonly id: string | null | undefined;
                      } | null | undefined;
                      readonly id: string;
                      readonly optionId: string;
                      readonly value: string | null | undefined;
                    } | null | undefined;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedValue?: {
                      readonly __typename: string;
                      readonly id: string;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraSingleSelectUserPickerField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraSingleSelectUserPickerField";
                    readonly fieldConfig: {
                      readonly isRequired: boolean | null | undefined;
                    } | null | undefined;
                    readonly fieldId: string;
                    readonly id: string;
                    readonly isEditableInIssueView: boolean | null | undefined;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly type: string;
                    readonly user: {
                      readonly __typename: "AppUser";
                      readonly accountId: string;
                      readonly accountStatus: AccountStatus;
                      readonly appType: string | null | undefined;
                      readonly id: string;
                      readonly name: string;
                      readonly picture: AGG$URL;
                    } | {
                      readonly __typename: string;
                      readonly accountId: string;
                      readonly accountStatus: AccountStatus;
                      readonly id: string;
                      readonly name: string;
                      readonly picture: AGG$URL;
                    } | null | undefined;
                  } | {
                    readonly __typename: "JiraSingleVersionPickerField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraSingleVersionPickerField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly type: string;
                    readonly version?: {
                      readonly id: string;
                      readonly versionId: string;
                    } | null | undefined;
                  } | {
                    readonly __typename: "JiraSprintField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraSprintField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedSprintsConnection: {
                      readonly edges: ReadonlyArray<{
                        readonly node: {
                          readonly endDate: AGG$DateTime | null | undefined;
                          readonly id: string;
                          readonly name: string | null | undefined;
                          readonly sprintId: string;
                          readonly state: JiraSprintState | null | undefined;
                        } | null | undefined;
                      } | null | undefined> | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraStatusCategoryField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraStatusCategoryField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly statusCategory: {
                      readonly id: string;
                      readonly name: string | null | undefined;
                      readonly statusCategoryId: string;
                    };
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraStatusField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraStatusField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly status: {
                      readonly id: string;
                      readonly name: string | null | undefined;
                      readonly statusCategory: {
                        readonly id: string;
                        readonly statusCategoryId: string;
                      } | null | undefined;
                      readonly statusId: string;
                    };
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraTeamViewField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraTeamViewField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly selectedTeam: {
                      readonly jiraSuppliedId: string;
                      readonly jiraSuppliedName: string | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraTimelineField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraTimelineField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly issue: {
                      readonly assigneeField: {
                        readonly id: string;
                        readonly user: {
                          readonly __typename: string;
                          readonly id: string;
                          readonly picture: AGG$URL;
                        } | null | undefined;
                      } | null | undefined;
                      readonly endDateViewField: {
                        readonly __typename: "JiraDatePickerField";
                        readonly date: AGG$Date | null | undefined;
                        readonly fieldId: string;
                        readonly id: string;
                      } | {
                        readonly __typename: string;
                        readonly fieldId: string;
                        readonly id: string;
                      } | null | undefined;
                      readonly id: string;
                      readonly issueId: string;
                      readonly issueTypeField: {
                        readonly id: string;
                        readonly issueType: {
                          readonly hierarchy: {
                            readonly level: number | null | undefined;
                          } | null | undefined;
                          readonly id: string;
                          readonly name: string;
                        } | null | undefined;
                      } | null | undefined;
                      readonly key: string;
                      readonly parentIssueField: {
                        readonly id: string;
                        readonly parentIssue: {
                          readonly id: string;
                          readonly issueId: string;
                          readonly key: string;
                        } | null | undefined;
                      } | null | undefined;
                      readonly startDateViewField: {
                        readonly __typename: "JiraDatePickerField";
                        readonly date: AGG$Date | null | undefined;
                        readonly fieldId: string;
                        readonly id: string;
                      } | {
                        readonly __typename: string;
                        readonly fieldId: string;
                        readonly id: string;
                      } | null | undefined;
                      readonly statusField: {
                        readonly id: string;
                        readonly status: {
                          readonly id: string;
                          readonly statusCategory: {
                            readonly id: string;
                            readonly statusCategoryId: string;
                          } | null | undefined;
                        };
                      } | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraTownsquareProjectField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraTownsquareProjectField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly isLinkEditable: boolean | null | undefined;
                    readonly issue: {
                      readonly id: string;
                    } | null | undefined;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly project: {
                      readonly atlasProjectKey: string | null | undefined;
                      readonly atlasProjectName: string | null | undefined;
                      readonly hasPermission: boolean | null | undefined;
                      readonly id: string;
                      readonly isWorkspaceActive: boolean | null | undefined;
                      readonly privateProject: boolean | null | undefined;
                    } | null | undefined;
                    readonly type: string;
                  } | {
                    readonly __typename: "JiraUrlField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraUrlField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly lazyIsEditableInIssueView?: boolean | null | undefined;
                    readonly name: string;
                    readonly type: string;
                    readonly uri: string | null | undefined;
                  } | {
                    readonly __typename: "JiraWatchesField";
                    readonly __id?: string;
                    readonly __isJiraIssueField: "JiraWatchesField";
                    readonly fieldId: string;
                    readonly id: string;
                    readonly type: string;
                    readonly watch: {
                      readonly count: AGG$Long | null | undefined;
                      readonly isWatching: boolean | null | undefined;
                    } | null | undefined;
                  } | {
                    readonly __typename: string;
                    readonly __id?: string;
                    readonly __isJiraIssueField: string;
                    readonly fieldId: string;
                    readonly id: string;
                    readonly type: string;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
                readonly totalCount: number | null | undefined;
              } | null | undefined;
              readonly type: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly fieldsByIdOrAlias: ReadonlyArray<{
          readonly __typename: "JiraCheckboxesField";
          readonly fieldId: string;
          readonly id: string;
          readonly selectedOptions: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly optionId: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "JiraLabelsField";
          readonly fieldId: string;
          readonly id: string;
          readonly selectedLabelsConnection: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly name: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "JiraMultipleSelectField";
          readonly fieldId: string;
          readonly id: string;
          readonly selectedOptions: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly optionId: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "JiraMultipleVersionPickerField";
          readonly fieldId: string;
          readonly id: string;
          readonly selectedVersionsConnection: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly versionId: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "JiraNumberField";
          readonly fieldId: string;
          readonly id: string;
          readonly number: number | null | undefined;
        } | {
          readonly __typename: "JiraPriorityField";
          readonly fieldId: string;
          readonly id: string;
          readonly priority: {
            readonly id: string;
            readonly priorityId: string;
          } | null | undefined;
        } | {
          readonly __typename: "JiraRadioSelectField";
          readonly fieldId: string;
          readonly id: string;
          readonly selectedOption: {
            readonly id: string;
            readonly optionId: string;
          } | null | undefined;
        } | {
          readonly __typename: "JiraSingleSelectField";
          readonly fieldId: string;
          readonly fieldOption: {
            readonly id: string;
            readonly optionId: string;
          } | null | undefined;
          readonly id: string;
        } | {
          readonly __typename: "JiraSingleSelectUserPickerField";
          readonly fieldId: string;
          readonly id: string;
          readonly user: {
            readonly __typename: string;
            readonly accountId: string;
            readonly id: string;
          } | null | undefined;
        } | {
          readonly __typename: "JiraSingleVersionPickerField";
          readonly fieldId: string;
          readonly id: string;
          readonly version: {
            readonly id: string;
            readonly versionId: string;
          } | null | undefined;
        } | {
          readonly __typename: "JiraSprintField";
          readonly fieldId: string;
          readonly id: string;
          readonly selectedSprintsConnection: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly sprintId: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "JiraStatusField";
          readonly fieldId: string;
          readonly id: string;
          readonly status: {
            readonly id: string;
            readonly name: string | null | undefined;
            readonly statusId: string;
          };
        } | {
          readonly __typename: string;
          readonly fieldId: string;
          readonly id: string;
        } | null | undefined> | null | undefined;
        readonly id: string;
        readonly issueId: string;
        readonly issueTypeField: {
          readonly id: string;
          readonly issueType: {
            readonly hierarchy: {
              readonly level: number | null | undefined;
            } | null | undefined;
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
        readonly key: string;
        readonly matchesIssueSearch: boolean | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CreateIssueControllerMutation = {
  rawResponse: CreateIssueControllerMutation$rawResponse;
  response: CreateIssueControllerMutation$data;
  variables: CreateIssueControllerMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldIdsOrAliases"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConditionalFormattingEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDensityFull"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEditableSyncLoaded"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isIdFieldEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isInlineEditingEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isIssueHierarchyEnabled"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLinkRelationshipFieldEnabled"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTimelineEnabled"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueCreateInput"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryFieldsByIdOrAlias"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryMatchesIssueSearch"
},
v15 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "issueCreateInput"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v17 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v18 = {
  "condition": "isIdFieldEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v17/*: any*/)
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "id"
},
v20 = {
  "kind": "ScalarField",
  "name": "key"
},
v21 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v22 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v23 = {
  "args": [
    {
      "kind": "Variable",
      "name": "projectKey",
      "variableName": "projectKey"
    }
  ],
  "kind": "ScalarField",
  "name": "canHaveChildIssues"
},
v24 = [
  {
    "kind": "Variable",
    "name": "idsOrAliases",
    "variableName": "fieldIdsOrAliases"
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v26 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v27 = {
  "kind": "ScalarField",
  "name": "statusId"
},
v28 = {
  "kind": "ScalarField",
  "name": "name"
},
v29 = {
  "kind": "ScalarField",
  "name": "priorityId"
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v29/*: any*/)
      ]
    }
  ],
  "type": "JiraPriorityField"
},
v31 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v32 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v33 = [
  (v32/*: any*/)
],
v34 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v35 = {
  "kind": "ScalarField",
  "name": "sprintId"
},
v36 = {
  "kind": "ScalarField",
  "name": "number"
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v36/*: any*/)
  ],
  "type": "JiraNumberField"
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v28/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraLabelsField"
},
v39 = [
  {
    "concreteType": "JiraOptionConnection",
    "kind": "LinkedField",
    "name": "selectedOptions",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraOptionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v33/*: any*/)
          }
        ]
      }
    ]
  }
],
v40 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v41 = [
  (v40/*: any*/)
],
v42 = {
  "condition": "shouldQueryMatchesIssueSearch",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "issueSearchInput",
          "variableName": "issueSearchInput"
        }
      ],
      "kind": "ScalarField",
      "name": "matchesIssueSearch"
    }
  ]
},
v43 = [
  {
    "kind": "Variable",
    "name": "fieldSetIds",
    "variableName": "fieldSetIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v44 = [
  (v19/*: any*/)
],
v45 = {
  "kind": "ScalarField",
  "name": "type"
},
v46 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v47 = {
  "kind": "ScalarField",
  "name": "value"
},
v48 = [
  (v47/*: any*/),
  (v19/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v49 = {
  "condition": "isInlineEditingEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lazyIsEditableInIssueView"
        }
      ]
    }
  ]
},
v50 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v51 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v52 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v53 = {
  "kind": "ScalarField",
  "name": "date"
},
v54 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v55 = {
  "kind": "ScalarField",
  "name": "text"
},
v56 = {
  "condition": "isEditableSyncLoaded",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditableInIssueView"
    }
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v58 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v19/*: any*/)
  ]
},
v59 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v19/*: any*/)
  ]
},
v60 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v61 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v62 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v63 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v58/*: any*/),
    (v19/*: any*/)
  ]
},
v64 = {
  "kind": "ScalarField",
  "name": "picture"
},
v65 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v66 = {
  "kind": "ScalarField",
  "name": "relationName"
},
v67 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v68 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v69 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v44/*: any*/)
},
v70 = {
  "kind": "ScalarField",
  "name": "href"
},
v71 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v72 = [
  (v25/*: any*/),
  (v26/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v53/*: any*/)
    ],
    "type": "JiraDatePickerField"
  },
  (v19/*: any*/)
],
v73 = [
  (v40/*: any*/),
  (v19/*: any*/)
],
v74 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraVersion",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": (v73/*: any*/)
    }
  ],
  "type": "JiraSingleVersionPickerField"
},
v75 = [
  (v25/*: any*/),
  (v19/*: any*/)
],
v76 = [
  (v32/*: any*/),
  (v19/*: any*/)
],
v77 = [
  {
    "concreteType": "JiraOptionConnection",
    "kind": "LinkedField",
    "name": "selectedOptions",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraOptionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v76/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CreateIssueControllerMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v15/*: any*/),
            "concreteType": "JiraIssueCreatePayload",
            "kind": "LinkedField",
            "name": "createIssue",
            "plural": false,
            "selections": [
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "highlightIssueRow"
                  },
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "condition": "isIssueHierarchyEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v23/*: any*/)
                    ]
                  },
                  {
                    "condition": "shouldQueryFieldsByIdOrAlias",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": (v24/*: any*/),
                        "kind": "LinkedField",
                        "name": "fieldsByIdOrAlias",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          (v26/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v28/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraStatusField"
                          },
                          (v30/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraSingleSelectUserPickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "fieldOption",
                                "plural": false,
                                "selections": (v33/*: any*/)
                              }
                            ],
                            "type": "JiraSingleSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "args": (v34/*: any*/),
                                "concreteType": "JiraSprintConnection",
                                "kind": "LinkedField",
                                "name": "selectedSprintsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraSprintEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraSprint",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v35/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "selectedSprintsConnection(first:1)"
                              }
                            ],
                            "type": "JiraSprintField"
                          },
                          (v37/*: any*/),
                          (v38/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "selectedOption",
                                "plural": false,
                                "selections": (v33/*: any*/)
                              }
                            ],
                            "type": "JiraRadioSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v39/*: any*/),
                            "type": "JiraMultipleSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v39/*: any*/),
                            "type": "JiraCheckboxesField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "selectedVersionsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v41/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraMultipleVersionPickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": (v41/*: any*/)
                              }
                            ],
                            "type": "JiraSingleVersionPickerField"
                          }
                        ]
                      }
                    ]
                  },
                  (v42/*: any*/),
                  {
                    "args": (v43/*: any*/),
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsById",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                          },
                          {
                            "kind": "Variable",
                            "name": "isDensityFull",
                            "variableName": "isDensityFull"
                          },
                          {
                            "kind": "Variable",
                            "name": "isEditableSyncLoaded",
                            "variableName": "isEditableSyncLoaded"
                          },
                          {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                          },
                          {
                            "kind": "Variable",
                            "name": "isLinkRelationshipFieldEnabled",
                            "variableName": "isLinkRelationshipFieldEnabled"
                          },
                          {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                          }
                        ],
                        "kind": "FragmentSpread",
                        "name": "IssueRow_fieldSets"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v10/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v13/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v12/*: any*/),
      (v11/*: any*/),
      (v14/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "CreateIssueControllerMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v15/*: any*/),
            "concreteType": "JiraIssueCreatePayload",
            "kind": "LinkedField",
            "name": "createIssue",
            "plural": false,
            "selections": [
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v44/*: any*/),
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "args": (v43/*: any*/),
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsById",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                              },
                              {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                  (v46/*: any*/),
                                  {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v19/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/),
                                          (v45/*: any*/),
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraIssueField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraAffectedServiceConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedAffectedServicesConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAffectedServiceEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAffectedService",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "serviceId"
                                                          },
                                                          (v28/*: any*/),
                                                          (v19/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraAffectedServicesField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "concreteType": "JiraCascadingOption",
                                                "kind": "LinkedField",
                                                "name": "cascadingOption",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": (v48/*: any*/)
                                                  },
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValue",
                                                    "plural": false,
                                                    "selections": (v48/*: any*/)
                                                  }
                                                ]
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraCascadingSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraCmdbObjectConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedCmdbObjectsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCmdbObjectEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraCmdbObject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "objectId"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "label"
                                                          },
                                                          {
                                                            "concreteType": "JiraCmdbAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                                "kind": "LinkedField",
                                                                "name": "mediaClientConfig",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "clientId"
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileId"
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaBaseUrl"
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaJwtToken"
                                                                  }
                                                                ]
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "url48"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "message"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraCMDBField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "args": (v50/*: any*/),
                                                "concreteType": "JiraComponentConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedComponentsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponent",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v51/*: any*/),
                                                          (v52/*: any*/),
                                                          (v19/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraComponentsField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v53/*: any*/),
                                              (v28/*: any*/),
                                              (v54/*: any*/),
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraDatePickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "dateTime"
                                              },
                                              (v28/*: any*/),
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraDateTimePickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraEpic",
                                                "kind": "LinkedField",
                                                "name": "epic",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "summary"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "color"
                                                  },
                                                  (v19/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraEpicLinkField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "renderedFieldHtml"
                                              }
                                            ],
                                            "type": "JiraFallbackField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v55/*: any*/),
                                              (v28/*: any*/),
                                              (v56/*: any*/),
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraSingleLineTextField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v57/*: any*/),
                                                  (v19/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraStatusCategoryField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v27/*: any*/),
                                                  (v58/*: any*/),
                                                  (v19/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraStatusField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "args": (v50/*: any*/),
                                                "concreteType": "JiraLabelConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedLabelsConnection",
                                                "plural": false,
                                                "selections": [
                                                  (v46/*: any*/),
                                                  {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraLabel",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v28/*: any*/),
                                                          (v59/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                              },
                                              (v28/*: any*/),
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraLabelsField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "small"
                                                      }
                                                    ]
                                                  },
                                                  (v28/*: any*/),
                                                  (v19/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraIssueTypeField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "parentIssue",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  {
                                                    "concreteType": "JiraColorField",
                                                    "kind": "LinkedField",
                                                    "name": "issueColorField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v59/*: any*/),
                                                      (v19/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "issueType",
                                                        "plural": false,
                                                        "selections": [
                                                          (v60/*: any*/),
                                                          (v28/*: any*/),
                                                          (v19/*: any*/)
                                                        ]
                                                      },
                                                      (v19/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v55/*: any*/),
                                                      (v19/*: any*/)
                                                    ]
                                                  },
                                                  (v19/*: any*/),
                                                  (v21/*: any*/),
                                                  (v61/*: any*/),
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                      {
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                              "issuetype",
                                                              "project",
                                                              "summary",
                                                              "status"
                                                            ]
                                                          }
                                                        ],
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v25/*: any*/),
                                                                  (v19/*: any*/),
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v26/*: any*/),
                                                                      (v55/*: any*/)
                                                                    ],
                                                                    "type": "JiraSingleLineTextField"
                                                                  },
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v26/*: any*/),
                                                                      {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v19/*: any*/),
                                                                          (v62/*: any*/),
                                                                          (v28/*: any*/),
                                                                          (v60/*: any*/),
                                                                          (v22/*: any*/)
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "type": "JiraIssueTypeField"
                                                                  },
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v26/*: any*/),
                                                                      {
                                                                        "concreteType": "JiraStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v19/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v19/*: any*/),
                                                                              (v57/*: any*/)
                                                                            ]
                                                                          }
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "type": "JiraStatusField"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                              (v62/*: any*/),
                                                              (v22/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraSingleLineTextField",
                                                        "kind": "LinkedField",
                                                        "name": "summaryField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraStatusField",
                                                        "kind": "LinkedField",
                                                        "name": "statusField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          (v26/*: any*/),
                                                          (v63/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v28/*: any*/),
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraParentIssueField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraPriority",
                                                "kind": "LinkedField",
                                                "name": "priority",
                                                "plural": false,
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "iconUrl"
                                                  },
                                                  (v19/*: any*/)
                                                ]
                                              },
                                              (v28/*: any*/),
                                              (v56/*: any*/),
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraPriorityField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v20/*: any*/),
                                                  {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "large"
                                                      }
                                                    ]
                                                  },
                                                  (v19/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraProjectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraResolution",
                                                "kind": "LinkedField",
                                                "name": "resolution",
                                                "plural": false,
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v19/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraResolutionField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraSprintConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedSprintsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSprintEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSprint",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          (v35/*: any*/),
                                                          (v28/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "state"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "endDate"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v28/*: any*/),
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraSprintField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v25/*: any*/),
                                                  (v28/*: any*/),
                                                  (v64/*: any*/),
                                                  (v65/*: any*/),
                                                  (v19/*: any*/),
                                                  (v31/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "AppUser"
                                                  }
                                                ]
                                              },
                                              (v54/*: any*/),
                                              (v56/*: any*/),
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraSingleSelectUserPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraRichText",
                                                "kind": "LinkedField",
                                                "name": "richText",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "adfValue",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "condition": "isDensityFull",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                            "kind": "LinkedField",
                                                            "name": "convertedPlainText",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "plainText"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "condition": "isDensityFull",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "json"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraRichTextField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraServiceManagementRequestType",
                                                "kind": "LinkedField",
                                                "name": "requestType",
                                                "plural": false,
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v60/*: any*/),
                                                  (v19/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraServiceManagementRequestTypeField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "args": (v34/*: any*/),
                                                "concreteType": "JiraIssueLinkConnection",
                                                "kind": "LinkedField",
                                                "name": "issueLinkConnection",
                                                "plural": false,
                                                "selections": [
                                                  (v46/*: any*/),
                                                  {
                                                    "concreteType": "JiraIssueLinkEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueLink",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                              (v61/*: any*/),
                                                              (v20/*: any*/),
                                                              {
                                                                "args": [
                                                                  {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                      "statusCategory"
                                                                    ]
                                                                  }
                                                                ],
                                                                "concreteType": "JiraIssueFieldConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fieldsById",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v25/*: any*/),
                                                                          {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                              (v58/*: any*/)
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                          },
                                                                          (v19/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ],
                                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                              },
                                                              {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "isResolved"
                                                                  }
                                                                ]
                                                              },
                                                              (v19/*: any*/)
                                                            ]
                                                          },
                                                          (v66/*: any*/),
                                                          (v19/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "issueLinkConnection(first:1)"
                                              }
                                            ],
                                            "type": "JiraIssueLinkField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "isStoryPointField"
                                              },
                                              (v36/*: any*/),
                                              (v28/*: any*/),
                                              (v49/*: any*/),
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                    "kind": "LinkedField",
                                                    "name": "formatConfig",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "formatStyle"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "formatUnit"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraNumberField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraCommentSummary",
                                                "kind": "LinkedField",
                                                "name": "commentSummary",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "canAddComment"
                                                  },
                                                  (v46/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraCommentSummaryField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "uri"
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraUrlField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "fieldOption",
                                                "plural": false,
                                                "selections": [
                                                  (v47/*: any*/),
                                                  (v59/*: any*/),
                                                  (v19/*: any*/),
                                                  (v32/*: any*/)
                                                ]
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraSingleSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "concreteType": "JiraOptionConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedOptions",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          (v47/*: any*/),
                                                          (v32/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraMultipleSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "concreteType": "JiraOptionConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedOptions",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          (v47/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraCheckboxesField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "concreteType": "JiraUserConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedUsersConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraUserEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v25/*: any*/),
                                                          (v31/*: any*/),
                                                          (v28/*: any*/),
                                                          (v64/*: any*/),
                                                          (v19/*: any*/),
                                                          (v65/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "email"
                                                              }
                                                            ],
                                                            "type": "AtlassianAccountUser"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraMultipleSelectUserPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "concreteType": "JiraTeamView",
                                                "kind": "LinkedField",
                                                "name": "selectedTeam",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedId"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedName"
                                                  }
                                                ]
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraTeamViewField"
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraTimeTrackingField",
                                                        "kind": "LinkedField",
                                                        "name": "timeTrackingField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          (v49/*: any*/),
                                                          (v67/*: any*/),
                                                          (v68/*: any*/),
                                                          (v26/*: any*/),
                                                          (v28/*: any*/),
                                                          (v45/*: any*/)
                                                        ]
                                                      },
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraOriginalTimeEstimateField"
                                              }
                                            ]
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraTimeTrackingField",
                                                        "kind": "LinkedField",
                                                        "name": "timeTrackingField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v67/*: any*/),
                                                          (v68/*: any*/),
                                                          (v19/*: any*/),
                                                          (v26/*: any*/),
                                                          (v28/*: any*/),
                                                          (v45/*: any*/)
                                                        ]
                                                      },
                                                      (v19/*: any*/)
                                                    ]
                                                  },
                                                  (v49/*: any*/)
                                                ],
                                                "type": "JiraOriginalTimeEstimateField"
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "selectedOption",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": "label",
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                  },
                                                  (v19/*: any*/),
                                                  (v51/*: any*/)
                                                ]
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraRadioSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "args": (v50/*: any*/),
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedVersionsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraVersionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          (v28/*: any*/),
                                                          (v51/*: any*/),
                                                          (v52/*: any*/),
                                                          (v40/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraMultipleVersionPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              (v69/*: any*/),
                                              {
                                                "args": (v50/*: any*/),
                                                "concreteType": "JiraGoalConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedGoals",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGoalEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGoal",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          (v20/*: any*/),
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              (v28/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "status"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v17/*: any*/)
                                                ],
                                                "storageKey": "selectedGoals(first:1000)"
                                              },
                                              (v49/*: any*/),
                                              (v17/*: any*/)
                                            ],
                                            "type": "JiraGoalsField"
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v69/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isLinkEditable"
                                                  },
                                                  {
                                                    "concreteType": "JiraTownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      {
                                                        "alias": "atlasProjectName",
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                      },
                                                      {
                                                        "alias": "atlasProjectKey",
                                                        "kind": "ScalarField",
                                                        "name": "key"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "privateProject"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "hasPermission"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isWorkspaceActive"
                                                      }
                                                    ]
                                                  },
                                                  (v49/*: any*/)
                                                ],
                                                "type": "JiraTownsquareProjectField"
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "args": (v50/*: any*/),
                                                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                "kind": "LinkedField",
                                                "name": "confluenceRemoteIssueLinks",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          (v70/*: any*/),
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "pageContent",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v25/*: any*/),
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v70/*: any*/)
                                                                    ],
                                                                    "type": "JiraConfluencePageContentDetails"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v46/*: any*/)
                                                ],
                                                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "concreteType": "JiraGroupConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedGroupsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGroup",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v19/*: any*/),
                                                          (v28/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v49/*: any*/)
                                            ],
                                            "type": "JiraMultipleGroupPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraFlag",
                                                "kind": "LinkedField",
                                                "name": "flag",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isFlagged"
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraFlagField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraWatch",
                                                "kind": "LinkedField",
                                                "name": "watch",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "count"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isWatching"
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraWatchesField"
                                          },
                                          {
                                            "condition": "isLinkRelationshipFieldEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraIssueLink",
                                                    "kind": "LinkedField",
                                                    "name": "issueLink",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "direction"
                                                      },
                                                      (v66/*: any*/),
                                                      {
                                                        "concreteType": "JiraIssueLinkType",
                                                        "kind": "LinkedField",
                                                        "name": "type",
                                                        "plural": false,
                                                        "selections": (v44/*: any*/)
                                                      }
                                                    ]
                                                  },
                                                  (v56/*: any*/),
                                                  (v49/*: any*/)
                                                ],
                                                "type": "JiraIssueLinkRelationshipTypeField"
                                              }
                                            ]
                                          },
                                          {
                                            "condition": "isTimelineEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      (v21/*: any*/),
                                                      {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                              (v28/*: any*/),
                                                              (v22/*: any*/),
                                                              (v19/*: any*/)
                                                            ]
                                                          },
                                                          (v19/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraParentIssueField",
                                                        "kind": "LinkedField",
                                                        "name": "parentIssueField",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                              (v21/*: any*/),
                                                              (v20/*: any*/),
                                                              (v19/*: any*/)
                                                            ]
                                                          },
                                                          (v19/*: any*/)
                                                        ]
                                                      },
                                                      (v20/*: any*/),
                                                      {
                                                        "concreteType": "JiraStatusField",
                                                        "kind": "LinkedField",
                                                        "name": "statusField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v63/*: any*/),
                                                          (v19/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraSingleSelectUserPickerField",
                                                        "kind": "LinkedField",
                                                        "name": "assigneeField",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                              (v25/*: any*/),
                                                              (v64/*: any*/),
                                                              (v19/*: any*/)
                                                            ]
                                                          },
                                                          (v19/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "args": (v71/*: any*/),
                                                        "kind": "LinkedField",
                                                        "name": "startDateViewField",
                                                        "plural": false,
                                                        "selections": (v72/*: any*/),
                                                        "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                      },
                                                      {
                                                        "args": (v71/*: any*/),
                                                        "kind": "LinkedField",
                                                        "name": "endDateViewField",
                                                        "plural": false,
                                                        "selections": (v72/*: any*/),
                                                        "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraTimelineField"
                                              }
                                            ]
                                          },
                                          (v17/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v18/*: any*/),
                      {
                        "condition": "isConditionalFormattingEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": (v50/*: any*/),
                                                    "concreteType": "JiraComponentConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedComponentsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraComponent",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "componentId"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                  }
                                                ],
                                                "type": "JiraComponentsField"
                                              },
                                              (v30/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "projectId"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraProjectField"
                                              },
                                              (v74/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v62/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraIssueTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "selectedValue",
                                                    "plural": false,
                                                    "selections": (v75/*: any*/)
                                                  }
                                                ],
                                                "type": "JiraSingleSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSelectableValueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedValues",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSelectableValueEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": (v75/*: any*/)
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraMultipleSelectField"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v18/*: any*/),
                  {
                    "condition": "isIssueHierarchyEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v19/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v23/*: any*/)
                    ]
                  },
                  {
                    "condition": "shouldQueryFieldsByIdOrAlias",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": (v24/*: any*/),
                        "kind": "LinkedField",
                        "name": "fieldsByIdOrAlias",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          (v26/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v19/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraStatusField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                  (v29/*: any*/),
                                  (v19/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraPriorityField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v31/*: any*/),
                                  (v19/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraSingleSelectUserPickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "fieldOption",
                                "plural": false,
                                "selections": (v76/*: any*/)
                              }
                            ],
                            "type": "JiraSingleSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "args": (v34/*: any*/),
                                "concreteType": "JiraSprintConnection",
                                "kind": "LinkedField",
                                "name": "selectedSprintsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraSprintEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraSprint",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v35/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "selectedSprintsConnection(first:1)"
                              }
                            ],
                            "type": "JiraSprintField"
                          },
                          (v37/*: any*/),
                          (v38/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "selectedOption",
                                "plural": false,
                                "selections": (v76/*: any*/)
                              }
                            ],
                            "type": "JiraRadioSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v77/*: any*/),
                            "type": "JiraMultipleSelectField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v77/*: any*/),
                            "type": "JiraCheckboxesField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "selectedVersionsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v73/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraMultipleVersionPickerField"
                          },
                          (v74/*: any*/),
                          (v19/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v42/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8d5bfd972fde66029f4613327f0f763b28fe23988fcf40528ed023963d9019f0",
    "metadata": {},
    "name": "CreateIssueControllerMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
    }
  }
};
})();

(node as any).hash = "2a101e882bc4ee8ec9c444bca45c2a46";

export default node;
